import * as Accordion from '@radix-ui/react-accordion';
import { AccordionContent, AccordionItem, AccordionTrigger, cn } from 'component-library';
import { ReactNode } from 'react';

export enum AccordionType {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
}

type AccordionWrapperBaseProps = {
  children: ReactNode;
  className?: string;
};

type AccordionWrapperSingleProps = AccordionWrapperBaseProps & {
  type: AccordionType.SINGLE;
  defaultValue?: string;
  collapsible?: boolean;
};

type AccordionWrapperMultipleProps = AccordionWrapperBaseProps & {
  type: AccordionType.MULTIPLE;
  defaultValue?: string[];
};

type AccordionWrapperProps = AccordionWrapperSingleProps | AccordionWrapperMultipleProps;

export const AccordionWrapper = ({ children, className, ...props }: AccordionWrapperProps) => {
  return (
    <Accordion.Root className={cn('flex flex-col gap-6', className)} {...props}>
      {children}
    </Accordion.Root>
  );
};

type AccordionSectionProps = {
  title: ReactNode;
  children: ReactNode;
  value: string;
  styles?: {
    item?: string;
    trigger?: string;
    content?: string;
  };
};

export const AccordionSection = ({ title, children, value, styles }: AccordionSectionProps) => {
  return (
    <AccordionItem className={cn('rounded-3xl', styles?.item)} value={value}>
      <AccordionTrigger className={cn('px-8', styles?.trigger)}>{title}</AccordionTrigger>
      <AccordionContent className={cn('border-t border-divider px-8', styles?.content)}>{children}</AccordionContent>
    </AccordionItem>
  );
};
